import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function Register() {
    const [err, setErr] = useState(null);
    const login = localStorage.getItem("user");
    const [affiliate, setAffiliate] = useState(null);
    const navigate = useNavigate();
    const [profile, setProfile] = useState(null);
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        if (login) {
            navigate("/");
        } else {
            const urlParams = new URLSearchParams(window.location.search);
            const refParam = urlParams.get("ref");
            if (refParam) {
                setAffiliate(refParam);
            }
            if (localStorage.getItem("affiliate")) {
                setAffiliate(localStorage.getItem("affiliate"));
            }
        }
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    const onSubmit = (data, e) => {
        e.preventDefault();
        const phoneNumberPattern = /^(0\d{9,10})$/;
        const regex = /^[a-zA-Z0-9]+$/;
        if (data.username.length < 6) {
            setError("username", { type: "minLength", message: "Tên đăng nhập tối thiểu 6 kí tự" });
            return;
        }
        if (data.username.length > 12) {
            setError("username", { type: "minLength", message: "Tên đăng nhập tối đa 12 kí tự" });
            return;
        }
        if (!regex.test(data.username)) {
            setError("username", { type: "minLength", message: "Tên đăng nhập không chứa khoảng trắng và ký tự đặc biệt" });
            return;
        }
        if (data.password.length < 6) {
            setError("password", { type: "minLength", message: "Mật khẩu tối thiểu 6 kí tự" });
            return;
        }
        if (data.password !== data.ippassword) {
            setError("ippassword", { type: "minLength", message: "Hai mật khẩu không khớp" });
            return;
        }
        if (!data.name) {
            data.name = data.username;
        }
        if (!data.sdt) {
            setError("sdt", { type: "minLength", message: "Vui lòng nhập số điện thoại" });
            return;
        }
        if (!phoneNumberPattern.test(data.sdt)) {
            setError("sdt", { type: "minLength", message: "Định dạng số điện thoại không hợp lệ" });
            return;
        }
        if (data.paypwd.length < 6) {
            setError("paypwd", { type: "minLength", message: "Mật khẩu rút tiền tối thiểu 6 kí tự" });
            return;
        }

        let formData;
        if (affiliate == null) {
            formData = {
                username: data.username.toLowerCase(),
                password: data.password,
                code: data.code === "" ? "admin" : data.code,
                sdt: data.sdt,
                name: data.name,
                paypwd: data.paypwd
            };
        } else {
            formData = {
                username: data.username.toLowerCase(),
                password: data.password,
                code: affiliate,
                sdt: data.sdt,
                name: data.name,
                paypwd: data.paypwd
            };
        }
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/register`, formData)
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Đăng ký thành công",
                    icon: "success",
                    buttons: "OK"
                }).then(() =>
                    axios
                        .post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                            username: data.username.toLowerCase(),
                            password: data.password
                        })
                        .then((res) => {
                            swal({
                                title: "Thông báo",
                                text: "Đăng nhập thành công",
                                icon: "success",
                                buttons: "OK"
                            }).then(() => {
                                localStorage.removeItem("user");
                                localStorage.removeItem("profile");
                                localStorage.removeItem("data");
                                localStorage.setItem("user", res.data.data);
                                window.location.href = "/";
                            });
                        })
                );
            })
            .catch((err) => {
                setErr(err.response?.data?.message ? err.response.data.message : "Đã có lỗi xảy ra!");
            });
    };

    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => setShowPassword(!showPassword);

    const [showPassword1, setShowPassword1] = useState(false);
    const toggleShowPassword1 = () => setShowPassword1(!showPassword1);

    const [showPassword2, setShowPassword2] = useState(false);
    const toggleShowPassword2 = () => setShowPassword2(!showPassword2);

    return (
        <>
            <style>
                {`
                /* TOÀN BỘ TRANG & VIDEO NỀN - ÉP KÍN MÀN HÌNH ĐỂ CHE FOOTER */
                .register-wrapper {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    font-family: Arial, sans-serif;
                    z-index: 99999;
                    overflow-y: auto;
                    background-color: #000;
                }
                .bg-video {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    object-fit: cover;
                    z-index: -2;
                }
                .bg-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.3); /* Làm tối nhẹ video */
                    z-index: -1;
                }

                /* CĂN GIỮA FORM */
                .register-content {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 100vh;
                    padding: 30px 20px;
                    box-sizing: border-box;
                }
                .register-box {
                    width: 100%;
                    max-width: 340px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                /* LOGO */
                .register-logo {
                    width: 250px;
                    height: auto;
                    margin-bottom: 25px;
                    object-fit: contain;
                }

                /* Ô NHẬP LIỆU (KÍNH MỜ) */
                .input-row {
                    width: 100%;
                    margin-bottom: 14px;
                    position: relative;
                }
                .input-control {
                    width: 100%;
                    height: 42px;
                    border-radius: 25px;
                    background-color: rgba(255, 255, 255, 0.22);
                    border: 1px solid rgba(255, 255, 255, 0.45);
                    padding: 0 45px 0 25px; /* Dịch text sang phải một chút để chừa chỗ cho dấu sao đỏ */
                    font-size: 14px;
                    color: #fff;
                    box-sizing: border-box;
                    outline: none;
                    backdrop-filter: blur(5px);
                    -webkit-backdrop-filter: blur(5px);
                    transition: all 0.3s ease;
                }
                .input-control:focus {
                    background-color: rgba(255, 255, 255, 0.35);
                    border-color: rgba(255, 255, 255, 0.9);
                }
                .input-control::placeholder {
                    color: rgba(255, 255, 255, 0.85);
                    font-size: 13px;
                }
                
                /* Dấu sao đỏ (*) */
                .required-star {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-35%);
                    color: #ff4d4d;
                    font-size: 16px;
                    font-weight: bold;
                    pointer-events: none;
                }

                /* Con mắt ẩn/hiện mật khẩu */
                .eye-btn {
                    position: absolute;
                    right: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: rgba(255, 255, 255, 0.85);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                }

                /* NÚT ĐĂNG KÝ (XANH BIỂN) */
                .btn-submit {
                    width: 100%;
                    height: 42px;
                    border-radius: 25px;
                    background: linear-gradient(90deg, #3bc6ff 0%, #007eff 100%);
                    border: none;
                    color: #fff;
                    font-weight: bold;
                    font-size: 15px;
                    cursor: pointer;
                    box-shadow: 0 4px 12px rgba(0, 126, 255, 0.35);
                    transition: background 0.3s ease, opacity 0.2s;
                    margin-top: 5px;
                }
                .btn-submit:hover {
                    opacity: 0.92;
                }

                /* LINK ĐĂNG NHẬP */
                .login-link {
                    text-align: center;
                    margin-top: 15px;
                    font-size: 13px;
                    color: rgba(255, 255, 255, 0.8);
                }
                .login-link span {
                    color: #00e5ff;
                    cursor: pointer;
                    text-decoration: underline;
                    font-weight: bold;
                    transition: color 0.2s ease;
                }
                .login-link span:hover {
                    color: #fff;
                }

                /* BANNER 1.1.1.1 */
                .banner-1111 {
                    width: 100%;
                    max-width: 240px;
                    margin-top: 25px;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: transform 0.2s ease;
                }
                .banner-1111:hover {
                    transform: scale(1.03);
                }

                /* THÔNG BÁO LỖI */
                .error-msg {
                    color: #ff4d4d;
                    font-size: 12px;
                    margin-top: 4px;
                    margin-left: 12px;
                    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.6);
                    font-weight: 500;
                }
                `}
            </style>

            <div className="register-wrapper">
                {/* VIDEO NỀN LẶP LẠI */}
                <video autoPlay loop muted playsInline className="bg-video">
                    <source src="https://www.sv368cpc1.tv/res/media/user-page-bg.9ea9f08.mp4" type="video/mp4" />
                </video>
                <div className="bg-overlay"></div>

                <div className="register-content">
                    <div className="register-box">
                        
                        {/* Logo SV368 */}
                          <img
                            src="https://i.ibb.co/RptZzQzN/wps-Logo-BIA66-Gold-3-20251106133142.png" 
                            alt="SV368" 
                            className="login-logo" 
                            style={{ backgroundImage: 'url(https://i.ibb.co/your-logo-url-if-any.png)', height: '55px' }} 
                            onClick={() => navigate("/")}
                        />

                        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                            
                            {/* Tên người dùng */}
                            <div className="input-row">
                                <span className="required-star">*</span>
                                <input 
                                    className="input-control" 
                                    type="text" 
                                    {...register("username")} 
                                    placeholder="Tên người dùng" 
                                />
                                {errors.username && <div className="error-msg">{errors.username.message}</div>}
                            </div>

                            {/* Mật khẩu */}
                            <div className="input-row">
                                <span className="required-star">*</span>
                                <input 
                                    className="input-control" 
                                    type={showPassword ? "text" : "password"} 
                                    {...register("password")} 
                                    placeholder="Mật khẩu" 
                                />
                                <div className="eye-btn" onClick={toggleShowPassword}>
                                    {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </div>
                                {errors.password && <div className="error-msg">{errors.password.message}</div>}
                            </div>

                            {/* Xác nhận mật khẩu */}
                            <div className="input-row">
                                <span className="required-star">*</span>
                                <input 
                                    className="input-control" 
                                    type={showPassword1 ? "text" : "password"} 
                                    {...register("ippassword")} 
                                    placeholder="Xác nhận mật khẩu" 
                                />
                                <div className="eye-btn" onClick={toggleShowPassword1}>
                                    {showPassword1 ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </div>
                                {errors.ippassword && <div className="error-msg">{errors.ippassword.message}</div>}
                            </div>

                            {/* Số điện thoại */}
                            <div className="input-row">
                                <span className="required-star">*</span>
                                <input 
                                    className="input-control" 
                                    type="tel" 
                                    {...register("sdt")} 
                                    placeholder="Số điện thoại" 
                                />
                                {errors.sdt && <div className="error-msg">{errors.sdt.message}</div>}
                            </div>

                            {/* Họ Tên */}
                            <div className="input-row">
                                <span className="required-star">*</span>
                                <input 
                                    className="input-control" 
                                    type="text" 
                                    {...register("name")} 
                                    placeholder="Họ và tên" 
                                />
                            </div>

                            {/* Mật khẩu rút tiền (Giữ lại logic cũ nhưng đồng bộ giao diện) */}
                            <div className="input-row">
                                <span className="required-star">*</span>
                                <input 
                                    className="input-control" 
                                    type={showPassword2 ? "text" : "password"} 
                                    {...register("paypwd")} 
                                    placeholder="Mật khẩu rút tiền" 
                                />
                                <div className="eye-btn" onClick={toggleShowPassword2}>
                                    {showPassword2 ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </div>
                                {errors.paypwd && <div className="error-msg">{errors.paypwd.message}</div>}
                            </div>

                            {/* Mã mời (Được kế thừa từ logic cũ của bạn) */}
                            <div className="input-row">
                                <span className="required-star" style={{color: 'transparent'}}>*</span> {/* Ẩn sao đỏ đi vì mã mời có thể ko bắt buộc */}
                                <input 
                                    className="input-control" 
                                    type="text" 
                                    {...register("code")} 
                                    placeholder="Mã mời" 
                                    defaultValue={affiliate !== null ? affiliate : ""} 
                                    readOnly={affiliate !== null} 
                                />
                                {errors.code && <div className="error-msg">{errors.code.message}</div>}
                            </div>

                            {/* Lỗi Server API */}
                            {err && <div className="error-msg" style={{ textAlign: "center", fontSize: "14px", marginTop: "10px", marginBottom: "10px" }}>{err}</div>}

                            {/* Nút bấm */}
                            <button className="btn-submit" type="submit">Đăng ký</button>

                            {/* Link chuyển sang trang Đăng nhập */}
                            <div className="login-link">
                                Quý khách đã có tài khoản <span onClick={() => navigate("/login")}>Đăng nhập</span>
                            </div>
                        </form>

                        {/* Ảnh Banner 1.1.1.1 */}
                        <img 
                            src="https://i.ibb.co/FFk94XB/image.png" 
                            alt="1.1.1.1 Banner" 
                            className="banner-1111" 
                            onClick={() => window.open('https://1.1.1.1/', '_blank')}
                        />

                    </div>
                </div>
            </div>
        </>
    );
}

export default Register;